/**
 * @file
 * Northeast Bank behaviors.
 */
(function () {

  'use strict';

  Drupal.behaviors.nebSiteEltropyVideoChat = {
    attach(context, settings) {
      (function (e, l, t, r, o, p) {
        e[r] = e[r] || { init: function () {e[r].q = arguments;} };
        o = l.createElement(t);
        p = l.getElementsByTagName(t)[0];
        o.async = 1;
        o.type = 'text/javascript';
        o.src = 'https://d1lvyn09g7nf92.cloudfront.net/elt-iva-resources-prod/chat/contact-widget-embed.js';
        p.parentNode.insertBefore(o, p);
      })
      (window, document, 'script', 'Eltropy');
      Eltropy.init({ domain: 'https://northebank.eltropy.com' });

    },
  };

}());
